const {
  isPlainObject
} = require('lodash');
const {
  getValue
} = require('@truqc/content-path');
const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate getObjectValueBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const object = await evaluateSource(source.object, content, parentContentPath, transientContext, nativeFunctions);
  if (!isPlainObject(object)) {
    return undefined;
  }
  const path = await evaluateSource(source.path, content, parentContentPath, transientContext, nativeFunctions);
  if (typeof path !== 'string') {
    return undefined;
  }
  const value = getValue(path, object);
  const evaluatedValue = await evaluateSource(value, content, parentContentPath, transientContext, nativeFunctions);
  return evaluatedValue;
};
module.exports = {
  evaluate
};